import { alignLeftCellStyle, alignCenterCellStyle } from '@common/cellStyles';

export default [
  {
    headerName: 'Connection Name',
    field: 'connName',
    width: 220,
    minWidth: 200,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Connection Type',
    field: 'connTypeName',
    width: 100,
    minWidth: 100,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Enabled Flag',
    field: 'enabledFlag',
    width: 100,
    minWidth: 80,
    ...alignCenterCellStyle,
  },
  {
    headerName: 'Inbound Name',
    field: 'inboundName',
    width: 220,
    minWidth: 200,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Outbound Name',
    field: 'outboundName',
    width: 220,
    minWidth: 200,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Inbound Folder Name',
    field: 'inboundFolderName',
    width: 130,
    minWidth: 110,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Outbound Folder Name',
    field: 'outboundFolderName',
    width: 130,
    minWidth: 110,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Generate JE Flag',
    field: 'generateJeFlag',
    width: 100,
    minWidth: 80,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'BSM JE Flag',
    field: 'bsmJeFlag',
    width: 100,
    minWidth: 80,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Source Folder',
    field: 'sourceFolder',
    width: 220,
    minWidth: 200,
    ...alignLeftCellStyle,
  },
  {
    headerName: 'Notification Email',
    field: 'notificationEmail',
    minWidth: 180,
    ...alignLeftCellStyle,
  },
  {
    field: 'lcdMcCloseStart',
    headerName: 'LCD MC Close Start (days)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'lcdMcCloseEnd',
    headerName: 'LCD MC Close End (days)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'lcdQcCloseStart',
    headerName: 'LCD QC Close Start (days)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'lcdQcCloseEnd',
    headerName: 'LCD QC Close End (days)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'lcdYeCloseStart',
    headerName: 'LCD YE Close Start (days)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'lcdYeCloseEnd',
    headerName: 'LCD YE Close End (days)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'scheduleType',
    headerName: 'Schedule Type',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'runInterval',
    headerName: 'Run Interval (minutes)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'jobInterval',
    headerName: 'Job Interval (minutes)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
  {
    field: 'runSla',
    headerName: 'Run SLA (minutes)',
    width: 170,
    minWidth: 150,
    ...alignCenterCellStyle,
  },
];
